function renderTimeline() { // or window.addEventListener("scroll"....
    const timelineContainers = document.querySelectorAll('.timeline-wrapper');

    // adjust height of the white part of the timeline line
    for (let timelineContainer of timelineContainers) {
        const timeline = timelineContainer.querySelector('.white-line');

        let offsetTop = timeline.offsetTop;
        let parent = timeline.offsetParent;

        while (parent) {
            offsetTop += parent.offsetTop;
            parent = parent.offsetParent;
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        const innerHeight = window.innerHeight;

        let offset = scrollTop - offsetTop + innerHeight / 2;
        if (offset < 0)
            offset = 0;

        timeline.style.height = `${offset}px`;

    }

    // adjust height of the white part of the timeline line
    for (let timelineContainer of timelineContainers) {
        const timeline = timelineContainer.querySelector('.line');
        const containers = timelineContainer.querySelectorAll('.container');

        if (!containers && containers.length < 1)
            continue;

        const lastContainerHeight = containers[containers.length-1].offsetHeight;

        timeline.style.height = `calc(100% - ${lastContainerHeight}px)`;
    }


    requestAnimationFrame(renderTimeline);
}

requestAnimationFrame(renderTimeline);
